/**
 * 18項目評価(日本語)
 */
export type IEvaluateCategoriesJa = typeof evaluateCategoriesJa[number];
export const evaluateCategoriesJa = [
  "立地#アクセスの良さ",
  "立地#都心・繁華街にあるか",
  "立地#見つけやすいか",
  "サービス#入店までの待ち時間",
  "サービス#接客",
  "サービス#駐車場の利便性",
  "サービス#料理の提供時間",
  "価格#水準",
  "価格#コストパフォーマンス",
  "価格#割引について",
  "雰囲気#装飾・雰囲気",
  "雰囲気#音楽・ノイズ",
  "雰囲気#店内・席の広さ",
  "雰囲気#清潔感",
  "料理#分量",
  "料理#味",
  "料理#見た目",
  "料理#おすすめできるか",
] as const;

/**
 * 18項目 + 総合評価 (日本語)
 */
export type IEvaluateCategoriesWithAllJa =
  typeof evaluateCategoriesWithAllJa[number];
export const evaluateCategoriesWithAllJa = [
  "総合評価",
  ...evaluateCategoriesJa,
] as const;

/**
 * 18項目評価 (キー)
 */
export type IEvaluateCategoryKeys = typeof evaluateCategoryKeys[number];
export const evaluateCategoryKeys = [
  "location_transportation",
  "location_downtown",
  "location_easy_to_find",
  "service_queue",
  "service_hospitality",
  "service_parking",
  "service_timely",
  "price_level",
  "price_cost_effective",
  "price_discount",
  "ambience_decoration",
  "ambience_noise",
  "ambience_space",
  "ambience_sanitary",
  "food_portion",
  "food_taste",
  "food_appearance",
  "food_recommend",
] as const;

/**
 * 18項目 + 総合評価 (キー)
 */
export type IEvaluateCategoryKeysWithAll =
  typeof evaluateCategoryKeysWithAll[number];
export const evaluateCategoryKeysWithAll = [
  "all",
  ...evaluateCategoryKeys,
] as const;

export const evaluateCategoryHash = {
  location_transportation: "立地#アクセスの良さ",
  location_downtown: "立地#都心・繁華街にあるか",
  location_easy_to_find: "立地#見つけやすいか",
  service_queue: "サービス#入店までの待ち時間",
  service_hospitality: "サービス#接客",
  service_parking: "サービス#駐車場の利便性",
  service_timely: "サービス#料理の提供時間",
  price_level: "価格#水準",
  price_cost_effective: "価格#コストパフォーマンス",
  price_discount: "価格#割引について",
  ambience_decoration: "雰囲気#装飾・雰囲気",
  ambience_noise: "雰囲気#音楽・ノイズ",
  ambience_space: "雰囲気#店内・席の広さ",
  ambience_sanitary: "雰囲気#清潔感",
  food_portion: "料理#分量",
  food_taste: "料理#味",
  food_appearance: "料理#見た目",
  food_recommend: "料理#おすすめできるか",
} as const;

export const evaluateCategoryHashWithAll = {
  all: "総合評価",
  ...evaluateCategoryHash,
} as const;

export type IPosNegKey = "all" | "pos" | "neg";
export const posNegHash = {
  all: "すべて",
  pos: "ポジティブ",
  neg: "ネガティブ",
} as const;
